"use strict";
/**
 * Helpers related to pedersen hashes.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.preComputeHashes = exports.getCacheablePedersenHash = void 0;
const constants_1 = require("../constants");
const crypto_1 = require("../lib/crypto");
const util_1 = require("../lib/util");
const constants_2 = require("./constants");
// Global state for all STARK signables.
const CACHE = {};
/**
 * Calculate a pedersen hash with commonly used parameters. The hash will be cached.
 */
async function getCacheablePedersenHash(left, right) {
    const leftString = left.toString(16);
    const rightString = right.toString(16);
    if (CACHE[leftString] === undefined) {
        CACHE[leftString] = {};
    }
    if (CACHE[leftString][rightString] === undefined) {
        CACHE[leftString][rightString] = await (0, crypto_1.getPedersenHash)(left, right);
    }
    return CACHE[leftString][rightString];
}
exports.getCacheablePedersenHash = getCacheablePedersenHash;
/**
 * Pre-compute commonly used hashes.
 *
 * This function may take a while to run.
 */
async function preComputeHashes(networkId) {
    const collateralAssetBn = (0, util_1.hexToBn)(constants_1.COLLATERAL_ASSET_ID_BY_NETWORK_ID[networkId]);
    await Promise.all([
        // Orders: hash(hash(sell asset, buy asset), fee asset)
        Promise.all(constants_1.SYNTHETIC_ASSETS.map(async (baseAsset) => {
            const baseAssetBn = (0, util_1.hexToBn)(constants_1.SYNTHETIC_ASSET_ID_MAP[baseAsset]);
            const [buyHash, sellHash] = await Promise.all([
                getCacheablePedersenHash(collateralAssetBn, baseAssetBn),
                getCacheablePedersenHash(baseAssetBn, collateralAssetBn),
            ]);
            await Promise.all([
                getCacheablePedersenHash(buyHash, collateralAssetBn),
                getCacheablePedersenHash(sellHash, collateralAssetBn),
            ]);
        })),
        // Transfers and conditional transfers: hash(transfer asset, fee asset)
        getCacheablePedersenHash(collateralAssetBn, constants_2.TRANSFER_FEE_ASSET_ID_BN),
    ]);
}
exports.preComputeHashes = preComputeHashes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFzaGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NpZ25hYmxlL2hhc2hlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7O0dBRUc7OztBQUlILDRDQUlzQjtBQUN0QiwwQ0FBZ0Q7QUFDaEQsc0NBQXNDO0FBRXRDLDJDQUF1RDtBQUV2RCx3Q0FBd0M7QUFDeEMsTUFBTSxLQUFLLEdBQXVDLEVBQUUsQ0FBQztBQUVyRDs7R0FFRztBQUNJLEtBQUssVUFBVSx3QkFBd0IsQ0FBQyxJQUFRLEVBQUUsS0FBUztJQUNoRSxNQUFNLFVBQVUsR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3JDLE1BQU0sV0FBVyxHQUFHLEtBQUssQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDdkMsSUFBSSxLQUFLLENBQUMsVUFBVSxDQUFDLEtBQUssU0FBUyxFQUFFO1FBQ25DLEtBQUssQ0FBQyxVQUFVLENBQUMsR0FBRyxFQUFFLENBQUM7S0FDeEI7SUFDRCxJQUFJLEtBQUssQ0FBQyxVQUFVLENBQUMsQ0FBQyxXQUFXLENBQUMsS0FBSyxTQUFTLEVBQUU7UUFDaEQsS0FBSyxDQUFDLFVBQVUsQ0FBQyxDQUFDLFdBQVcsQ0FBQyxHQUFHLE1BQU0sSUFBQSx3QkFBZSxFQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztLQUNyRTtJQUNELE9BQU8sS0FBSyxDQUFDLFVBQVUsQ0FBQyxDQUFDLFdBQVcsQ0FBQyxDQUFDO0FBQ3hDLENBQUM7QUFWRCw0REFVQztBQUVEOzs7O0dBSUc7QUFDSSxLQUFLLFVBQVUsZ0JBQWdCLENBQ3BDLFNBQW9CO0lBRXBCLE1BQU0saUJBQWlCLEdBQUcsSUFBQSxjQUFPLEVBQUMsNkNBQWlDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQztJQUVoRixNQUFNLE9BQU8sQ0FBQyxHQUFHLENBQUM7UUFDaEIsdURBQXVEO1FBQ3ZELE9BQU8sQ0FBQyxHQUFHLENBQUMsNEJBQWdCLENBQUMsR0FBRyxDQUFDLEtBQUssRUFBRSxTQUFTLEVBQUUsRUFBRTtZQUNuRCxNQUFNLFdBQVcsR0FBRyxJQUFBLGNBQU8sRUFBQyxrQ0FBc0IsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDO1lBQy9ELE1BQU0sQ0FBQyxPQUFPLEVBQUUsUUFBUSxDQUFDLEdBQUcsTUFBTSxPQUFPLENBQUMsR0FBRyxDQUFDO2dCQUM1Qyx3QkFBd0IsQ0FBQyxpQkFBaUIsRUFBRSxXQUFXLENBQUM7Z0JBQ3hELHdCQUF3QixDQUFDLFdBQVcsRUFBRSxpQkFBaUIsQ0FBQzthQUN6RCxDQUFDLENBQUM7WUFDSCxNQUFNLE9BQU8sQ0FBQyxHQUFHLENBQUM7Z0JBQ2hCLHdCQUF3QixDQUFDLE9BQU8sRUFBRSxpQkFBaUIsQ0FBQztnQkFDcEQsd0JBQXdCLENBQUMsUUFBUSxFQUFFLGlCQUFpQixDQUFDO2FBQ3RELENBQUMsQ0FBQztRQUNMLENBQUMsQ0FBQyxDQUFDO1FBRUgsdUVBQXVFO1FBQ3ZFLHdCQUF3QixDQUFDLGlCQUFpQixFQUFFLG9DQUF3QixDQUFDO0tBQ3RFLENBQUMsQ0FBQztBQUNMLENBQUM7QUF0QkQsNENBc0JDIn0=